var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WPBaseDatepicker',_vm._b({attrs:{"range":_vm.range},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'WPBaseDatepicker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }